const Preloader = () => {
    return(
        <>
            <div className="preloader" />
        </>
    )
}

export default Preloader